module.exports = __webpack_public_path__ + "static/media/man.7b4349da.png";